import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { InputTextModule } from '../../ui/input-text/input-text.module';
import { InputIdentityNoComponent } from './input-identity-no.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
  ],
  declarations: [InputIdentityNoComponent],
  exports: [InputIdentityNoComponent],
})
export class InputIdentityNoModule {}
